module.exports = __webpack_public_path__ + "static/media/Castle-Selected.7c96cfaa.svg";